(function () {
  function init(root) {
    var track = root.querySelector('.ab-ba__track');
    if (!track || track.dataset.abInit) return;
    track.dataset.abInit = '1';
    var next = root.querySelector('.ab-ba__arrow--next');
    var prev = root.querySelector('.ab-ba__arrow--prev');
    var fill = root.querySelector('.ab-ba__bar span');
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (fill) fill.style.width = Math.min(100, ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100) + '%';
      if (prev) prev.style.display = track.scrollLeft > 8 ? 'flex' : 'none';
      if (next) next.style.display = track.scrollLeft < max - 8 ? 'flex' : 'none';
    }
    function step(d) {
      var c = track.querySelector('.ab-ba__card');
      track.scrollBy({ left: d * (c ? c.offsetWidth + 16 : 300), behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function all() { document.querySelectorAll('.ab-ba').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
